// angular material table data source filtering
export function applyFilter(event: Event) {
  // get value to filter from html element
  const filterValue = (event.target as HTMLInputElement).value;

  // return filter for data source
  return filterValue.trim().toLowerCase();
}
